import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { valueRender } from '@repo/toolkit/conditional-render'
import { toFullName } from '@repo/toolkit/to-full-name'
import { UserFiveIcon, UserSevenIcon } from '@repo/ui/icons'
import UserRoleCard from '@repo/ui/user-role-card'
import { useQuery } from '@tanstack/react-query'

import { getCenterFacTerrain } from '../../../api/centers/get-center-fac-terrain'
import { getCenterManager } from '../../../api/centers/get-center-manager'
import { useObserver } from '../../../lib/contexts/observer'
import { affectedStaffMainFields } from '../../../lib/types/fields/affected-staffs/affected-staff'
import { formatPhoneNumber } from '../../../utils/functions/format-phone-number'

type Props = {
  id: number
}

const CenterMainStaffBadgeInfo = ({ id }: Props) => {
  if (!id) throw new Error('CenterMainStaffBadgeInfo: id is required')

  const { data: facTerrain, refetch: refetchFacTerrain } = useQuery({
    queryKey: ['centers', id, 'fac-terrain'],
    queryFn: () => getCenterFacTerrain(id)
  })

  const { data: centerManager } = useQuery({
    queryKey: ['center-manager', id, affectedStaffMainFields],
    queryFn: () => getCenterManager(id, affectedStaffMainFields)
  })

  useObserver({
    key: 'refetch-center-manager-and-fac-terrain',
    update: () => {
      refetchFacTerrain()
    }
  })

  return (
    <div className="flex flex-row gap-3">
      <UserRoleCard
        label="Responsable du centre"
        value={valueRender(centerManager, ({ staff, phoneNumber }) =>
          `${toFullName(staff.firstName, staff.lastName, { options: { mode: 'lastname-firstname' } })} ${phoneNumber ? formatPhoneNumber(phoneNumber) : ''}`.trim()
        )}
        variant="fushia"
        icon={UserSevenIcon}
      />

      <UserRoleCard
        label="FAC Terrain"
        value={valueRender(facTerrain ?? undefined, ({ staff, facNumber }) =>
          `${toFullName(staff.firstName, staff.lastName, { options: { mode: 'lastname-firstname' } })} ${facNumber ? formatPhoneNumber(facNumber) : ''}`.trim()
        )}
        variant="blue"
        icon={() => <UserFiveIcon filled={false} color={tailwindColors.blue.DEFAULT} />}
      />
    </div>
  )
}

export default CenterMainStaffBadgeInfo
